export const companiesCompanyIdEmailSelfServeConfigurationData =
  "/companies/:company_id/email_self_serve/:app_group_id/configuration_data";
